import { useFeatureFlag } from '../../../utils/feature-flag';

export const CS_LITE = 'cs_lite';

export function useIsCSLite(): boolean | undefined {
  return useFeatureFlag(CS_LITE);
}
